import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmPasswordModalComponent } from './../modal/confirm-password/confirm-password-modal.component';
import { TermsAndConditionsModalComponent } from './../modal/terms-and-conditions/terms-and-conditions-modal.component';
import { UserManagerService } from './user-manager.service';

@Injectable({
    providedIn: 'root'
})
export class PasswordAccessService {
    private readonly PASSWORD_STORAGE_KEY = 'passwordConfirmedAt';
    private currentRoute: string | null = null;

    constructor(
        private modalService: NgbModal,
        private userManagerService: UserManagerService,
    ) {}

	public confirmPassword(params: { term: string }): Observable<boolean> {
		if (!this.isLocked()) return of(true);

        var needAcceptTerms: boolean = false;

        if (params.term) {    
            this.userManagerService.getCheckTermsOfUse(params.term).subscribe((response: boolean) => needAcceptTerms = !response)
        }

		const modal = this.modalService.open(ConfirmPasswordModalComponent, { backdrop: 'static', keyboard: false, centered: true, windowClass: 'confirm-password' });

        return from(modal.result).pipe(
            switchMap((result: boolean) => {
                if (!result) return of(false);

                if (!needAcceptTerms) {
                    this.unlock();
                    return of(true)
                };

                return this.acceptTermsAndConditions(params.term);
            }),
            catchError(() => of(false))
        );
	}

    private unlock(term?: string): void {
        if (term) {
            this.userManagerService.postSaveTermsOfUse({ term })
                .subscribe((response: any) => {
                    if (response) localStorage.setItem(this.PASSWORD_STORAGE_KEY, new Date().toString());
                })
        } else {
            localStorage.setItem(this.PASSWORD_STORAGE_KEY, new Date().toString());
        }
    }

    private isLocked(): boolean {
        const confirmedAt: string | null = localStorage.getItem(this.PASSWORD_STORAGE_KEY);

        if (!confirmedAt) return true;

        const confirmedDate: Date = new Date(confirmedAt);
        const today = new Date();

        return (
            confirmedDate.getFullYear() !== today.getFullYear() ||
            confirmedDate.getMonth() !== today.getMonth() ||
            confirmedDate.getDate() !== today.getDate()
        );
	}

    private acceptTermsAndConditions(term: string): Observable<boolean> {
		const modal = this.modalService.open(TermsAndConditionsModalComponent, { backdrop: 'static', keyboard: false, centered: true, windowClass: 'terms-and-conditions' });

		return from(modal.result).pipe(
			map((result: boolean) => {
				if (result) {
					this.unlock(term);
					return true;
				}

				return false;
			}),
			catchError(() => of(false))
		);
	}
}